module.exports = __webpack_public_path__ + "img/logo@2x.dc61fada.png";